import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

// Connects to data-controller="search"
export default class extends Controller {
  static targets = ["container"]
  static values = { url: String }

  connect() {
    this._timeout = null
  }

  disconnect() {
    clearTimeout(this._timeout)
  }

  search(e) {
    clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this._performSearch(e.target.value), 600)
  }

  async _performSearch(q) {
    if (q.length <= 2) {
      this.containerTarget.innerHTML = ""
      return
    }

    const response = await post(this.urlValue, {
      body: JSON.stringify({ q })
    })

    if (response.statusCode === 204) {
      this.containerTarget.innerHTML = `Sem resultados para:<br><b>${q}</b>`
    } else if (response.ok) {
      this.containerTarget.innerHTML = await response.html
    }
  }
}
